<template>
  <div>
    <my-pages-header
      :companyId="companyUserData.Company ? companyUserData.Company.Id : ''"
      :activeService="activeService"
      :additionalService="additionalService"
      :rating="companyUserData.Company"
      :price="calculatedPrice"
      isCompany="true"
    ></my-pages-header>
    <my-pages-menu :routes="menuRoutes"></my-pages-menu>
    <router-view
      v-if="!isLoading && !error"
      :isCompany="isCompany"
      :companyUserData="companyUserData.User"
      :companyData="companyUserData.Company"
    ></router-view>
    <loader class="c-m-loader--large" v-else-if="isLoading"></loader>
    <error-state v-else-if="error"></error-state>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import {
  GET_COMPANY_USER,
  GET_ACTIVE_REQUEST_SERVICE,
  IS_LOADING,
  GET_ERROR,
  GET_CALCULATED_ACTIVE_SERVICE_PRICE,
  GET_ADDITIONAL_SERVICE
} from "../store/store-models/my-pages-company-model";

import MyPagesMenu from "./components/molecules/MoleculeMyPagesMenu.vue";
import MyPagesHeader from "./components/organisms/my-pages-sections/OrganismMyPagesHeader";
import Loader from "./components/molecules/MoleculeLoader.vue";
import ErrorState from "./components/molecules/MoleculeErrorState.vue";

export default {
  components: {
    MyPagesMenu,
    MyPagesHeader,
    Loader,
    ErrorState
  },
  props: ["isCompany"],
  data() {
    return {
      menuRoutes: []
    };
  },
  computed: {
    ...mapGetters({
      isLoading: IS_LOADING,
      error: GET_ERROR,
      companyUserData: GET_COMPANY_USER,
      activeService: GET_ACTIVE_REQUEST_SERVICE,
      additionalService: GET_ADDITIONAL_SERVICE,
      calculatedPrice: GET_CALCULATED_ACTIVE_SERVICE_PRICE,

    })
  },
  methods: {
    assignMenuByRole() {
      this.$router.options.routes.forEach(route => {
        if (route.path === "/mina-sidor" && route.children) {
          route.children.forEach(children => {
            if (
              children.name !== "Mina Sidor" &&
              children.meta.role.includes("Company")
            ) {
              this.menuRoutes.push({
                name: children.name,
                path: children.path
              });
            }
          });
        }
      });
    }
  },
  created() {
    this.assignMenuByRole();
  }
};
</script>





// WEBPACK FOOTER //
// src/views/MyPagesCompany.vue